import React from 'react';
import { useSpecSheetField } from '../../../../../queries/useSpecSheetField';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface AppliancesProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Appliances: React.FC<AppliancesProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [appliances, setAppliances] = useSpecSheetField(
        propertyGuid,
        (s) => s.values?.['Interior Features']?.['Appliances'] ?? '',
        (s, v) => ({ ...s, values: { ...s.values, 'Interior Features': { ...s.values?.['Interior Features'], Appliances: v } } })
    );
    const label = 'Appliances';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={appliances}
                />
            ) : (
                <TextBox
                    value={appliances ?? ''}
                    onChange={(value) => setAppliances(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
